/* eslint-disable import/prefer-default-export */
import type { State } from '@src/redux/configureStore'
import type { ObjectItem } from '@src/redux/reducers/objects/summary'
import { getAccountNameById } from '@src/utils/accounts'
import { map } from 'lodash'
import { getHumanNameByType } from '@src/utils/resource.utils'
import { ResourceTypeEnum } from '@src/endpoints/services/commonHdr.service'
import { defaultHandleStatus, paramsWithFilter } from '@src/endpoints/helpers'
import {
  GraphQueryMgr,
  ObjectQueryReq
} from '@src/endpoints/services/graphQueryMgr.service'
import * as ActionCreators from './action.creators'

function serverErrors(errors?: string) {
  return (dispatch: any, getState: () => State) => {
    dispatch(
      ActionCreators.summaryErrors({
        isPending: false
      })
    )
  }
}

export function getObjectsOverview(useFilter = true) {
  return (dispatch, getState: () => State) => {
    const { filter, auth, shell } = getState()
    const { tenant } = auth
    const { account_info = [] } = tenant || {}
    const { resourceTypes = {} } = shell
    const params = {} as ObjectQueryReq
    dispatch(
      ActionCreators.changeSummaryState({
        isPending: true
      })
    )
    GraphQueryMgr.ObjectQuery({
      params: useFilter ? paramsWithFilter(params, filter) : params
    })
      .then(res => defaultHandleStatus(res, serverErrors, true, dispatch))
      .then(res => {
        const { object_summary_info = [] } = res
        const list: ObjectItem[] = object_summary_info.map(item => {
          const object = { ...item } as ObjectItem
          object.object_type = getHumanNameByType(
            ResourceTypeEnum[item?.type],
            resourceTypes
          )
          object.account_name = getAccountNameById(
            item.account_id,
            account_info
          )
          object.actions_ut = {
            READ: `${item.used_read_cnt || 0}/${item.read_cnt || 0}`,
            WRITE: `${item.used_write_cnt || 0}/${item.write_cnt || 0}`,
            ADMIN: `${item.used_admin_cnt || 0}/${item.admin_cnt || 0}`
          }
          object.actions_str = map(object.actions_ut).join(', ')
          return object
        })
        dispatch(ActionCreators.getOverviewStatsSuccess(list))
      })
      .catch((res: Response) => dispatch(serverErrors(res?.statusText)))
  }
}
